import { ConfigProvider } from "antd";
import enUS from "antd/lib/locale/en_US";
import GlobalStyle from "assets/styles/globalStyle";
import { BrowserRouter } from "react-router-dom";
import { msalConfig } from "authConfig";
import { MsalProvider } from "@azure/msal-react";
import { AuthenticationResult, EventType, PublicClientApplication } from "@azure/msal-browser";
import { AppRouter } from "./AppRouter";

const msalInstance = new PublicClientApplication(msalConfig);

msalInstance.addEventCallback((event) => {
  if (event.eventType === EventType.LOGIN_SUCCESS) {
    const result = event.payload as AuthenticationResult;
    msalInstance.setActiveAccount(result.account);
    
    localStorage.setItem('msal_token', result.accessToken);
    
    window.location.href = '/dashboard';
  } 
  else if (event.eventType === EventType.LOGIN_FAILURE) {
    console.error('Login failed:', event.error);
  }
  else if (event.eventType === EventType.ACQUIRE_TOKEN_SUCCESS) {
    const result = event.payload as AuthenticationResult;
    localStorage.setItem('msal_token', result.accessToken);
  }
  else if (event.eventType === EventType.ACQUIRE_TOKEN_FAILURE) {
    console.error('Token acquisition failed:', event.error);
    window.location.href = '/login';
  }
});

const App: React.FC = () => {
  return (
    <BrowserRouter basename="/">
      <MsalProvider instance={msalInstance}>
        <GlobalStyle />
        <ConfigProvider locale={enUS}>
          <AppRouter />
        </ConfigProvider>
      </MsalProvider>
    </BrowserRouter>
  );
};

export default App;
